var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderTeam',{attrs:{"header":"รายงานและการสรุปยอด","img_header":_vm.header_image,"link_back":"summary"}}),_c('MenuTeamReportAndSummaryList'),_c('DetailEmployeeSummaryList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }